angular.module('memberWhitelist', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/member-whitelist/member-whitelist.module.js